import "../app.css";

   function OO(v) {
      return(
       <option value={v.op}>{v.op}</option>
      )
   }
   export default OO 